import { styled } from 'stitches.config'

export const ProductDetailsRoot = styled('div', {
  background: '$accent-white',
  padding: '$6 $2',

  '@bp2': {
    padding: '$2 $4 $4',
  },
})

export const ProductDetailsContainer = styled('div', {
  maxWidth: '800px',
  margin: '0 auto',

  '& > div > div > button': {
    fontSize: '$h5',
    lineHeight: '$h5',
    letterSpacing: '$h5',
  }
})

export const TableWrapper = styled('table', {
  paddingBottom: '$2',
  borderCollapse: 'collapse',
  width: '100%',

  '& th': {
    fontSize: '$headline',
    lineHeight: '$headline',
    fontWeight: '$medium',
    letterSpacing: '$body',
    verticalAlign: 'bottom',
    paddingBottom: '6px',
    textAlign: 'left',
  },
  '& thead': {
    borderBottom: '1px solid $accent-black',
  },
  '& tbody tr:first-child td': {
    paddingTop: '12px',
  },
  '& th:nth-child(1)': {
    width: '40%',
  },
  '& th:nth-child(2)': {
    width: '60%',
  },
  '& td': {
    fontSize: '$body',
    lineHeight: '$body',
    letterSpacing: '$body',
    padding: '4px',
  },
})

export const TableRoot = styled('div', {
  background: '$tertiary-200',
  padding: '32px 16px 16px',
  marginTop: '$2',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  '@bp2': {
    padding: '40px 40px 16px',
  },
})

export const AdditionalInfo = styled('div', {
  width: '100%',
  textAlign: 'right',
})
